import { useState, useEffect, useCallback } from 'react';
import { THEMES } from '../lib/constants';

const THEME_STORAGE_KEY = 'puzzle-theme';

export function useTheme() {
  const [theme, setTheme] = useState(() => {
    if (typeof window !== 'undefined') {
      return localStorage.getItem(THEME_STORAGE_KEY) || 'default';
    }
    return 'default';
  });
  
  const applyTheme = useCallback((newTheme) => {
    const root = document.documentElement;
    
    // Remove all theme attributes
    Object.keys(THEMES).forEach(t => {
      if (t !== 'default') {
        root.removeAttribute('data-theme');
      }
    });
    
    // Apply new theme
    if (newTheme !== 'default') {
      root.setAttribute('data-theme', newTheme);
    }
    
    setTheme(newTheme);
    localStorage.setItem(THEME_STORAGE_KEY, newTheme);
  }, []);
  
  // Apply theme on mount
  useEffect(() => {
    applyTheme(theme);
  }, [applyTheme, theme]);
  
  return {
    theme,
    setTheme: applyTheme,
    themes: THEMES
  };
}
